import { render, staticRenderFns } from "./OrderHousing.vue?vue&type=template&id=479ef247&scoped=true"
import script from "./OrderHousing.vue?vue&type=script&lang=js"
export * from "./OrderHousing.vue?vue&type=script&lang=js"
import style0 from "./OrderHousing.vue?vue&type=style&index=0&id=479ef247&prod&lang=scss&scoped=true"
import style1 from "./OrderHousing.vue?vue&type=style&index=1&id=479ef247&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ef247",
  null
  
)

export default component.exports